import React, { useState, useEffect } from "react";
import axios from "axios";
import { useWs } from "../dialer/WsWrapper";
import { useAuth } from "../../context/AuthContext";

const getFormattedDate = (_date) => {
  const date = new Date(_date);

  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const month = months[date.getMonth()];
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  const formattedDate = `${month} ${day}, ${hours}:${minutes}:${seconds}`;
  return formattedDate;
};

const CallHistory = ({ items, missed, allActive, incoming, onlineNow }) => {
  const {
    setActiveCall,
    startCall,
    setToken,
    setDialing,
    dialing,
    activeCall,
  } = useWs();
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);

  // Helper function to get startTime from rawData for online calls
  const getStartTime = (call) => {
    let d = {};
    if (call.startTime) return call.startTime;
    if (allActive && allActive.length > 0) {
      const matchingCall = allActive.find(
        (item) => item.callId === call.callId,
      );
      if (matchingCall) {
        d.startTime = matchingCall.startTime;
        d.group = matchingCall.group;
      }
    }
    return d;
  };

  const ringClient = async (call) => {
    if (dialing || activeCall) {
      return;
    }
    try {
      const { status, data } = await axios.post(
        "https://callcenter-client.teech.tv/api/token",
        {
          display_name: user.name,
          lesson_title: call.clientName,
          role: "ROLE_USER",
          lesson_id: call.callId,
          user_id: call.agentId,
          call_direction: "outgoing",
        },
      );
      if (status === 200) {
        const updateSuccess = await updateAgent(call);
        if (updateSuccess) {
          setToken(data.token);
          setActiveCall(call);
          startCall(data.token, false);
        }
      }
    } catch (error) {
      if (error.message) {
        alert(error.message);
      } else {
        alert("Internal Server Error! Please try it later");
      }
    }
  };

  const updateAgent = async (call) => {
    try {
      const response = await axios.post(
        "https://callcenter.teech.tv/api/calls",
        {
          callId: call.callId,
          clientId: call.clientId,
          state: call.state,
          agentId: user.agentId,
          agentName: user.name,
          call_direction: "outgoing",
        },
      );

      if (response.status === 200) {
        // Second request on success
        try {
          await axios.post(
            "https://callcenter-euwscall.teech.tv:3006/api/call/",
            {
              callId: call.callId,
              clientId: call.clientId,
              state: call.state,
              call_direction: "outgoing",
            },
          );
        } catch (error) {
          console.error("Error sending ringingTo state:", error);
          // Don't fail the whole operation if second request fails
        }
        return true;
      }

      return false;
    } catch (error) {
      console.error("Error updating agent:", error);
      return false;
    }
  };

  const acceptCall = async (call) => {
    if (!loading) {
      const notification = document.getElementById("notification");
      if (notification) {
        notification.pause();
      }
      setLoading(true);
      try {
        const response = await axios.post(
          `https://callcenter.teech.tv/api/calls/${call.callId}/accept`,
          {
            agentId: user.agentId,
            agentName: user.name,
          },
        );
        if (response.status === 200) {
          start(call);
        } else {
          alert(
            response.data.error || "Internal Server Error! Please try it later",
          );
        }
      } catch (error) {
        const msg =
          error?.response?.data?.error ||
          "Internal Server Error! Please try it later";
        alert(msg);
      } finally {
        setLoading(false);
      }
    }
  };

  const start = async (call) => {
    if (!loading) {
      setLoading(true);
      try {
        const { status, data } = await axios.post(
          "https://callcenter-client.teech.tv/api/token",
          {
            display_name: user.name,
            lesson_title: call.clientName,
            role: "ROLE_USER",
            lesson_id: call.callId,
            user_id: call.agentId,
          },
        );
        if (status === 200) {
          setToken(data.token);
          setActiveCall(call);
          startCall(data.token, true);
        }
      } catch (error) {
        if (error.message) {
          alert(error.message);
        } else {
          alert("Internal Server Error! Please try it later");
        }
      }
    }
  };

  return (
    <>
      {items.length > 0 &&
        items.map((call, index) => {
          if (
            onlineNow &&
            !call.created_call_date &&
            !getStartTime(call).startTime
          ) {
            return null;
          }
          console.log(call.startTime, call.created_call_date);
          if (onlineNow) {
            const startTime =
              call.created_call_date || getStartTime(call).startTime;
            const callTime = new Date(startTime);
            const now = new Date();
            const thirtyMinutesInMs = 60 * 60 * 1000;
            if (now - callTime > thirtyMinutesInMs) {
              return null;
            }
          }
          return (
            <div
              key={`${call.callId}-${index}`}
              className="call-center__section__list__item"
            >
              <div className="call-center__section__list__item__user">
                <div className="call-center__section__list__item__user__name">
                  {call.clientName && call.clientName.includes("[PoC]")
                    ? call.clientId
                    : call.clientName}
                  {getStartTime(call).group && (
                    <div
                      className="call-center__section__list__item__time__missed"
                      style={{
                        color: "#808080",
                        fontSize: "12px",
                        fontWeight: "400",
                        marginTop: "3px",
                      }}
                    >
                      {getStartTime(call).group}
                    </div>
                  )}
                </div>
                {/* <div className="call-center__section__list__item__user__info">
                <span className={`fi fi-${call.user.country}`} />
                <div className="call-center__section__list__item__user__browser">
                  {call.user.browser}
                </div>
                <div className="call-center__section__list__item__user__os">
                  {call.user.os}
                </div>
              </div> */}
              </div>
              <div className="call-center__section__list__item__info">
                <a
                  href={call.user_source}
                  target="_blank"
                  className="call-center__section__list__item__info__issue"
                >
                  {call.user_source}
                </a>
              </div>
              {((timeToShow) => {
                if (!timeToShow) return null;
                return (
                  <div className="call-center__section__list__item__time">
                    <div className="call-center__section__list__item__time__missed">
                      {getFormattedDate(timeToShow)}
                    </div>
                  </div>
                );
              })(
                onlineNow && call.created_call_date
                  ? call.created_call_date
                  : getStartTime(call).startTime,
              )}
              <div className="call-center__section__list__item__controls">
                {call.state === "started" && (
                  <button
                    className="call-center__section__list__item__controls__btn call-center__section__list__item__controls__btn--call"
                    onClick={() => ringClient(call)}
                  />
                )}
                {call.state === "ringing" && (
                  <button
                    className="call-center__section__list__item__controls__btn call-center__section__list__item__controls__btn--call"
                    onClick={() => acceptCall(call)}
                  />
                )}
                {call.state === "active" && (
                  <div className="call-center__section__list__item__controls__active">
                    On call
                  </div>
                )}
              </div>
            </div>
          );
        })}
      <div className="call-center__no-calls">
        {incoming ? "No incoming calls" : "No online clients"}
      </div>
      {/* {items.length === 0 && (
        <div className="call-center__no-calls">
          {incoming ? "No incoming calls" : "No online clients"}
        </div>
      )}*/}
    </>
  );
};

export default CallHistory;
